export const convertObjToQueryString = (
  obj: Record<string, string | number | boolean | null | undefined>,
) => {
  const queryParams = new URLSearchParams();
  Object.entries(obj).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      queryParams.append(key, String(value));
    }
  });

  return queryParams.toString();
};
